import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';

// Import Components
import StackedColumnChart from './StackedColumnChart';
import WelcomeComp from './WelcomeComp';
import MonthlyEarning from './MonthlyEarning';
import SalesChannelsOverview from './SalesChannelsOverview'; // Renamed from SocialSource
import ActivityComp from './ActivityComp';
import TopSellingMedicines from './TopSellingMedicines'; // Renamed from TopCities
import LatestTranaction from './LatestTranaction';

// Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

// Import Images
const modalimage1 = 'https://placehold.co/600x400';
const modalimage2 = 'https://placehold.co/600x400';

// Define interfaces
interface Report {
  title: string;
  iconClass: string;
  description: string;
}

interface ChartData {
  name: string;
  data: number[];
}

// Static data for pharmacy metrics
const staticReports: Report[] = [
  { title: 'Sales', iconClass: 'bx-cart', description: '1,500' },
  { title: 'Revenue', iconClass: 'bx-wallet', description: 'PKR 450,000' },
  { title: 'Medicines Stocked', iconClass: 'bx-package', description: '320' },
];

const staticChartData: ChartData[] = [
  {
    name: 'Tablets',
    data: [120, 150, 130, 170, 140, 160, 180, 200, 190, 210, 230, 250],
  },
  {
    name: 'Syrups',
    data: [50, 60, 55, 70, 65, 80, 90, 85, 100, 110, 120, 130],
  },
  {
    name: 'Injections',
    data: [30, 40, 35, 50, 45, 60, 70, 65, 80, 90, 100, 110],
  },
];

const DashboardMedico: React.FC<WithTranslation> = ({ t }) => {
  const [modal, setModal] = useState<boolean>(false);
  const [periodData, setPeriodData] = useState<ChartData[]>(staticChartData);
  const [periodType, setPeriodTypekin] = useState<string>('yearly');

  const onChangeChartPeriod = (pType: string) => {
    setPeriodTypekin(pType);
    setPeriodData(staticChartData);
  };

  // Meta title

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={t('Dashboards')} breadcrumbItem={t('Pharmacy Dashboard')} />

          <Row>
            <Col xl={4}>
              <WelcomeComp />
              <MonthlyEarning />
            </Col>
            <Col xl={8}>
              <Row>
                {staticReports.map((report, key) => (
                  <Col md={4} key={`_col_${key}`}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">{report.title}</p>
                            <h4 className="mb-0">{report.description}</h4>
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i className={`bx ${report.iconClass} font-size-24`}></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>

              <Card>
                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">Medicine Sales</h4> {/* Updated title */}
                    <div className="ms-auto">
                      <ul className="nav nav-pills">
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames({ active: periodType === 'weekly' }, 'nav-link')}
                            onClick={() => onChangeChartPeriod('weekly')}
                            id="one_month"
                          >
                            Week
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames({ active: periodType === 'monthly' }, 'nav-link')}
                            onClick={() => onChangeChartPeriod('monthly')}
                            id="one_month"
                          >
                            Month
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames({ active: periodType === 'yearly' }, 'nav-link')}
                            onClick={() => onChangeChartPeriod('yearly')}
                            id="one_month"
                          >
                            Year
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <StackedColumnChart
                    periodData={periodData}
                    dataColors='["--bs-primary", "--bs-warning", "--bs-success"]'
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={4}>
              <SalesChannelsOverview />
            </Col>
            <Col xl={4}>
              <ActivityComp />
            </Col>
            <Col xl={4}>
              <TopSellingMedicines />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <LatestTranaction />
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={modal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={() => setModal(!modal)}
      >
        <div>
          <ModalHeader toggle={() => setModal(!modal)}>Sales Details</ModalHeader>{' '}
          {/* Updated title */}
          <ModalBody>
            <p className="mb-2">
              Invoice ID: <span className="text-primary">#SI1234</span>
            </p>
            <p className="mb-4">
              Customer Name: <span className="text-primary">Ali Khan</span>
            </p>

            <div className="table-responsive">
              <Table className="table table-centered table-nowrap">
                <thead>
                  <tr>
                    <th scope="col">Medicine</th>
                    <th scope="col">Medicine Name</th>
                    <th scope="col">Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">
                      <div>
                        <img src={modalimage1} alt="" className="avatar-sm" />
                      </div>
                    </th>
                    <td>
                      <div>
                        <h5 className="text-truncate font-size-14">Paracetamol 500mg</h5>
                        <p className="text-muted mb-0">PKR 50 x 20</p>
                      </div>
                    </td>
                    <td>PKR 1000</td>
                  </tr>

                  <tr>
                    <th scope="row">
                      <div>
                        <img src={modalimage2} alt="" className="avatar-sm" />
                      </div>
                    </th>
                    <td>
                      <div>
                        <h5 className="text-truncate font-size-14">Ibuprofen 200mg</h5>
                        <p className="text-muted mb-0">PKR 100 x 5</p>
                      </div>
                    </td>
                    <td>PKR 500</td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <h6 className="m-0 text-end">Sub Total:</h6>
                    </td>
                    <td>PKR 1500</td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <h6 className="m-0 text-end">Shipping:</h6>
                    </td>
                    <td>Free</td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <h6 className="m-0 text-end">Total:</h6>
                    </td>
                    <td>PKR 1500</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={() => setModal(!modal)}>
              Close
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(DashboardMedico);
